import { Atom } from 'jotai';

import { InvoiceQueryFilters } from 'openapi';

import { CounterpartyFilterType } from 'utils/enums/Counterparty';
import { FilterType } from 'utils/enums/FilterType';
import { AppRoutesEnum } from 'utils/routes';

import {
  invoicesFiltersAtom,
  invoicesFiltersAtomForApproval,
  invoicesFiltersAtomForAccounting,
  invoicesFiltersAtomForPayment,
  revenueFiltersAtom
} from 'state/state';

export const getInvoicesFiltersAtomByType = (
  filterType?: FilterType | CounterpartyFilterType,
  stateRoute?: AppRoutesEnum
): Atom<InvoiceQueryFilters> => {
  if (
    stateRoute === AppRoutesEnum.REVENUE ||
    stateRoute === AppRoutesEnum.COMPANY_REVENUE
  ) {
    return revenueFiltersAtom;
  }

  switch (filterType) {
    case FilterType.Approval:
      return invoicesFiltersAtomForApproval;
    case FilterType.Accounting:
      return invoicesFiltersAtomForAccounting;
    case FilterType.Payment:
      return invoicesFiltersAtomForPayment;
    default:
      return invoicesFiltersAtom;
  }
};

const ROUTES_ALL = {
  [FilterType.Initial]: AppRoutesEnum.INVOICES,
  [FilterType.Approval]: AppRoutesEnum.INVOICES_APPROVAL,
  [FilterType.Accounting]: AppRoutesEnum.INVOICES_ACCOUNTING,
  [FilterType.Payment]: AppRoutesEnum.INVOICES_PAYMENT,
  [CounterpartyFilterType.NotValidated]:
    AppRoutesEnum.COMPANY_COUNTERPARTIES_NOT_VALIDATED,
  [CounterpartyFilterType.Default]:
    AppRoutesEnum.COMPANY_COUNTERPARTIES_NOT_VALIDATED
};

const ROUTES_SINGLE = {
  [FilterType.Initial]: AppRoutesEnum.COMPANY_INVOICES,
  [FilterType.Approval]: AppRoutesEnum.COMPANY_INVOICES_APPROVAL,
  [FilterType.Accounting]: AppRoutesEnum.COMPANY_INVOICES_ACCOUNTING,
  [FilterType.Payment]: AppRoutesEnum.COMPANY_INVOICES_PAYMENT,
  [CounterpartyFilterType.NotValidated]:
    AppRoutesEnum.COMPANY_COUNTERPARTIES_NOT_VALIDATED,
  [CounterpartyFilterType.Default]:
    AppRoutesEnum.COMPANY_COUNTERPARTIES_NOT_VALIDATED
};

export const getRouteForBackNavigation = (
  state: string,
  filterType: FilterType | CounterpartyFilterType,
  companyId?: string
) => {
  const injectCompanyIdToRoute = (route: string) =>
    companyId ? route.replace(':companyId', String(companyId)) : route;

  if (state === AppRoutesEnum.REVENUE) {
    return AppRoutesEnum.REVENUE;
  }

  if (state === AppRoutesEnum.COMPANY_REVENUE) {
    return injectCompanyIdToRoute(AppRoutesEnum.COMPANY_REVENUE);
  }

  if (state === AppRoutesEnum.INVOICES) {
    return ROUTES_ALL[filterType];
  }

  if (state) {
    return injectCompanyIdToRoute(ROUTES_SINGLE[filterType]);
  }

  const isRevenue = window.location.pathname.includes('revenue');

  if (isRevenue) {
    return companyId
      ? injectCompanyIdToRoute(AppRoutesEnum.COMPANY_REVENUE)
      : AppRoutesEnum.REVENUE;
  }

  return companyId
    ? injectCompanyIdToRoute(ROUTES_SINGLE[filterType])
    : ROUTES_ALL[filterType];
};
